import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'section-indicator',
    templateUrl: './section-indicator.component.html',
    styleUrls: ['./section-indicator.component.scss'],
    standalone: false
})
export class SectionIndicatorComponent implements OnInit {

  @Input() number: Number = 1;
  @Input() text: string = 'Section Description';
  @Input() isActive: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
